<template>
  <div class="wrap">
    <div class="search-page-wrap">
      <div class="data-table-title white">アカウント設定</div>
      <!-- テーブルタイトル -->

      <el-tabs v-model="activeName" class="tab-report">

        <el-tab-pane label="アカウント情報" name="account_info">
          <div class="setting-wrap" style="min-height:260px" v-loading="loading" v-if="loading"></div>
          <accountInfo v-else :member_info="userdata.member_info"/>
        </el-tab-pane>

        <el-tab-pane label="メールアドレス・パスワード" name="mail_pass">
          <EmailandPassword :member_info="userdata.member_info"/>
        </el-tab-pane>

      </el-tabs>
    </div>


  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const getUserDataAPI = root + "/api/auth/load_userdata";
import accountInfo from "./account_info";
import EmailandPassword from "./email_password";


export default {
  name: "setting",
  components: {
    accountInfo,
    EmailandPassword,
  },
  data() {
    return {
      activeName: "plan",
      loading: true,
      userdata: {},
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {
    this.loadUserData();
    this.loadActive();
    this.scrollTop();
    this.$store.dispatch("changeActive", "account_setting");
  },
  methods: {
    scrollTop() {
      window.scroll({
        //画面を上部に移動
        top: 0,
        behavior: "instant",
      });
    },
    loadActive() {
      if (this.$route.query.activeName == null) {
        this.activeName = "account_info";
      } else {
        this.activeName = this.$route.query.activeName;
      }
    },
    loadUserData() {
      this.axios
        .get(getUserDataAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            type: "setting"
          },
        })
        .then((response) => {
          this.userdata = response.data;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
  watch: {
    $route(to) {
      this.loadActive();
      this.scrollTop();
      if (to.path == "/setting/upgrade") {
        this.$router.push("/setting");
      }
    },
  },
  filters: {
  },
};
</script>
